export default "__VITE_ASSET__CW_R4cCs__"